import React, {Component} from 'react';
import {Card, Container, Grid, Icon} from "semantic-ui-react";
import StaticText from "../components/StaticText";

export default class ContactPage extends Component {

    render() {
        return <div className="page-container padding">
            <Container>
                <Card fluid>
                    <Card.Content>
                        <Card.Description>
                            <StaticText label="contact"/>
                        </Card.Description>
                    </Card.Content>
                </Card>
            </Container>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/pages/contact.js